module.exports = __webpack_public_path__ + "img/kz.3d973b6d.svg";